import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '@/utils/api';
import { toast } from 'sonner'; // Import toast for notifications

const AuthContext = createContext();
// Hardcoded Admin Email for frontend permission checks
const ADMIN_EMAIL = 'admin@buggyberry.com';

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const userData = await authAPI.getMe();
        userData.isAdmin = userData.email === ADMIN_EMAIL; // Set isAdmin flag
        setUser(userData);
      } catch (error) {
        console.error("Auth Check Failed:", error);
        localStorage.removeItem('token');
        setUser(null);
      }
    }
    setLoading(false);
  };

  const login = async (credentials) => {
    try {
      const data = await authAPI.login(credentials);
      data.user.isAdmin = data.user.email === ADMIN_EMAIL; // Set isAdmin flag
      
      localStorage.setItem('token', data.token);
      setUser(data.user);
      toast.success("Welcome back!");
      return data;
    } catch (error) {
      console.error("Login Error:", error);
      throw error; // Throw to let the UI handle the specific error message
    }
  };

  // --- UPDATED REGISTER FUNCTION ---
  const register = async (userData) => {
    try {
      // 1. Create the user in WordPress (Returns user data, but NO token)
      await authAPI.register(userData);

      // 2. Auto-Login immediately to get the Token
      const loginData = await authAPI.login({
        email: userData.email,
        password: userData.password
      });

      // 3. Set Admin flag (if applicable)
      loginData.user.isAdmin = loginData.user.email === ADMIN_EMAIL;

      // 4. Save Session
      localStorage.setItem('token', loginData.token);
      setUser(loginData.user);
      
      toast.success("Registration successful! You are now logged in.");
      return loginData;

    } catch (error) {
      console.error("Registration flow error:", error);
      // WooCommerce errors often come in error.response.data.message
      const msg = error.response?.data?.message || "Registration failed. Please try again.";
      toast.error(msg);
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    toast.info("Logged out successfully");
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};